import { Carousel, Collapse } from "antd";
import { Button } from "antd/lib/radio";
import * as React from "react";

const { Panel } = Collapse;

export interface State {
  activePanelKeys?: string[];
}

export interface Props {
  columns: any[];
  rows: any[];
  className?: string;
}

export default class MobileTableOverview extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { activePanelKeys: [] };
  }
  renderCollapsePanels = (columns: any[], rowIndex: number) => {
    let panels: JSX.Element[] = [];

    columns.forEach((column) => {
      panels.push(
        <Panel key={column.key} header={column.title}>
          {column.render("", {} as any, rowIndex)}
        </Panel>
      );
    });

    return panels;
  };

  renderCollapses = (colums: any[], rows: any[]) => {
    const { activePanelKeys } = this.state;

    let collapses: JSX.Element[] = [];

    rows.forEach((row: any, rowIndex: number) => {
      collapses.push(
        <Collapse
          activeKey={activePanelKeys}
          onChange={(key) => this.onActivePanelChange(key as string[])}
          key={rowIndex}
        >
          {this.renderCollapsePanels(colums, rowIndex)}
        </Collapse>
      );
    });

    return collapses;
  };

  onActivePanelChange = (activePanelKeys: string[]) => {
    this.setState({ activePanelKeys });
  };

  render() {
    const { columns, rows, className } = this.props;

    return (
      <Carousel
        className={`form-details-section-carousel ${className}`}
        customPaging={(index) => (
          <Button className={"form-details-section-carousel-btn"}>
            {index + 1}
          </Button>
        )}
        infinite={false}
        dotPosition={"bottom"}
        dots={true}
      >
        {this.renderCollapses(columns, rows)}
      </Carousel>
    );
  }
}
